export default "__VITE_ASSET__C7vnsJ$q__"